import { SurveyName } from '~/lib/constants/survey/SurveyName';

const TOTAL_SCORE_KEY = 'Total score';
const GLOBAL_SCORE_KEY = 'Global score';

export const SurveyNameToChartPrimaryKeyMap: Partial<
  Record<SurveyName, string>
> = {
  [SurveyName.AIMS]: TOTAL_SCORE_KEY,
  [SurveyName.EDE_Q]: GLOBAL_SCORE_KEY,
  [SurveyName.CET]: TOTAL_SCORE_KEY,
  [SurveyName.PHQ8]: TOTAL_SCORE_KEY,
  [SurveyName.PHQ9]: TOTAL_SCORE_KEY,
  [SurveyName.GAD7]: TOTAL_SCORE_KEY,
  [SurveyName.C_SSRS_SINCE_LAST_CONTACT]: TOTAL_SCORE_KEY,
  [SurveyName.AUDIT]: TOTAL_SCORE_KEY,
  [SurveyName.DUDIT]: TOTAL_SCORE_KEY,
  [SurveyName.FNS]: TOTAL_SCORE_KEY,
  [SurveyName.QUALITY_OF_LIFE]: GLOBAL_SCORE_KEY,
  [SurveyName.PCL5]: TOTAL_SCORE_KEY,
};
